import './global.types';

export class IQuestionConfigurator {
  surveyConfigurator: any;
  position: number;
  key: string;
  optionKeyToRating: {};
  optionKeyToText: {};
  serverContext: any;
  data: any;
  configuration: any;
  i18n: any;
  validator: any;

  // eslint-disable-next-line no-useless-constructor, no-empty-function
  constructor(props: any) {
  }

  isValid(answers: any): boolean {
    throw new Error('Not implemented');
  }

  isVisible(answers: any): boolean {
    throw new Error('Not implemented');
  }

  getDefaultData(): Object {
    throw new Error('Not implemented');
  }

  getDefaultDirtyState(bool: boolean): Object {
    throw new Error('Not implemented');
  }

  isEmail(): boolean {
    throw new Error('Not implemented');
  }

  isRating(): boolean {
    throw new Error('Not implemented');
  }

  isComment(): boolean {
    throw new Error('Not implemented');
  }

  getFeedbackData(answers: any): any {
    throw new Error('Not implemented');
  }

  getView(): (props: any) => JSX.Element {
    throw new Error('Method not implemented.');
  }
}

export interface I18n {
  getString(key, options?: any): string;
}

export interface Question {
  isRequired: boolean;
  Type: typeof IQuestionConfigurator;
  key: string;
  page: number;
  position: number;
  // The title of the question may be dependent on the answers to other questions.
  getTitle?: (answers: any, surveyConfigurator: any) => string;
  // The visibility of a question may dependent on the answers to other questions.
  isVisible?: (answers: any) => boolean;
  // The description of the question may be dependent on the answers to other questions.
  getDescription?: (answers: any, surveyConfigurator: any) => string;
  href?: string,
  linkText?: string,
}

interface SelectionOption {
  key: string;
  text: string;
  hasInput?: boolean;
  href?: string;
  linkText?: string;
  placeholder?: string;
  maxLength?: number;
}

export interface RatingOption extends SelectionOption {
  key: '1' | '2' | '3' | '4' | '5';
  rating: 0.2 | 0.4 | 0.6 | 0.8 | 1.0;
  hasInput?: false;
}

export interface RatingData {
  selectedOption: string;
}

interface RatingQuestion extends Question {
  key: 'rating';
  options: RatingOption[];
  // if data is set, it will be used to prefill the question
  data?: RatingData;
}

export interface SingleSelectionData {
  selectedOption: string;
  [key: string]: string;
}

interface SingleSelectionQuestion extends Question {
  options: SelectionOption[];
  // if data is set, it will be used to prefill the question
  data?: SingleSelectionData;
}

export interface MultipleSelectionData {
  [key: string]: {
    input: string,
    selected: boolean,
  },
}

interface MultipleSelectionQuestion extends Question {
  options: SelectionOption[];
  // if data is set, it will be used to prefill the question
  data?: MultipleSelectionData;
}

export interface CommentData {
  input: string,
}

interface CommentQuestion extends Question {
  maxLength?: number;
  placeholder?: string;
  // if data is set, it will be used to prefill the question
  data?: CommentData;
}

interface EmailOption extends SelectionOption {
  key: 'yes' | 'no';
}

export interface EmailData {
  selectedOption: 'yes' | 'no';
  yes?: string,
}

interface EmailQuestion extends Question {
  key: 'email';
  options: EmailOption[];
  // if data is set, it will be used to prefill the question
  data?: EmailData;
}

export type QuestionConfiguration = RatingQuestion | SingleSelectionQuestion | MultipleSelectionQuestion | CommentQuestion | EmailQuestion;

export interface PageConfiguration {
}

export type Others = {
  shouldHideInputWhenNotSelected?: boolean;
  isThankYouPageEnabled?: boolean;
  isGlobalModalStyleEnabled?: boolean;
  userActionAnalysisEnabled?: boolean;
  combineTextInputToComment?: boolean;
  // survey which triggered by user's action
  // e.g. click on a button, is considered as user initiated survey
  isUserInitiatedSurvey?: boolean;
  shouldAutoClose?: boolean;
  isInPageMiddle?: boolean;
  isModeless?: boolean;
  isBlocking?: boolean;
}

export interface SurveyConfiguration {
  // feature area is used to classify the feedback. You can find and create feature areas at
  // https://ocv.microsoft.com/#/manage/?aid=a9bfe3b9-40d8-443d-9d80-ba3369aa1463
  featureArea: string;
  // up to one rating question per survey
  rating?: RatingQuestion;
  // up to one email question per survey
  email?: EmailQuestion;
  // no restriction on the number of selection/comment questions per survey
  questions?: QuestionConfiguration[];
  // style json object is used to customize the look and feel of the survey.
  style?: any;
  // other configuration flags
  others?: Others;
  // properties for over writing the modal properties
  modalSettings?: any;
}
